export const deviceAction = {
  refetchDeviceList: (state, action) => {
    state.shouldRefetch = action.payload;
  },
};
